import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './PlusIcon.scss'

class PlusIcon extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      hovered: false
    }
  }

  render () {
    const plusIconClass = classNames('PlusIcon', {
      'PlusIcon--active': this.props.active,
      'PlusIcon--activeHovered': this.props.active && this.state.hovered
    })

    const { onClick, onMouseEnter, onMouseLeave } = this.props

    return (
      <div
        className={plusIconClass}
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          if (onClick) onClick()
        }}
        onMouseEnter={() => {
          this.setState({ hovered: true })
          if (onMouseEnter) onMouseEnter()
        }}
        onMouseLeave={() => {
          this.setState({ hovered: false })
          if (onMouseLeave) onMouseLeave()
        }}
      >
        <div>
          <span>+</span>
        </div>
      </div>
    )
  }
}

PlusIcon.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
}

export default PlusIcon
